export const fileNames = Object.freeze({
    LISTING_EXCHANGE_WIDGET: '/autos/light/v1/exchange_widget_$platform$.$ext$',
    LISTING_EXCHANGE_TRADE_IN_WIDGET: '/autos/light/v1/exchange_trade_in_widget_$platform$.$ext$'
});
